import type { ReactNode } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";
import useCss from "../../../../../../hooks/useCss";
import styles from "../styles";
import SbuxTranslate from "../../../../../../components/SbuxTranslate";

interface LexDataTableProps {
  containerClass: string;
  columns: string[];
  children: ReactNode;
}

const LexDataTable = ({
  containerClass,
  columns,
  children,
}: LexDataTableProps) => {
  const classes = useCss(styles);
  return (
    <TableContainer
      component={Paper}
      variant="outlined"
      className={containerClass}
    >
      <Table size="small">
        <TableHead className={classes.compactTableHead}>
          <TableRow>
            {columns.map((col) => (
              <TableCell key={col} className={classes.compactTableHeadCell}>
                <SbuxTranslate>{col}</SbuxTranslate>
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>{children}</TableBody>
      </Table>
    </TableContainer>
  );
};

export default LexDataTable;
